import React from 'react';
import { Box } from '@mui/material';

const G1 = '#9FE870', G2 = '#163300', G3 = '#4caf50', G4 = '#2e7d32', BG = '#f0faf0';
const R = ({ x, y, w, h, fill, rx = 3, opacity = 1, style }) => <rect x={x} y={y} width={w} height={h} rx={rx} fill={fill} opacity={opacity} style={style} />;
const T = ({ x, y, size = 6, fill = G2, weight = 400, opacity = 1, children }) => <text x={x} y={y} fontSize={size} fill={fill} fontWeight={weight} fontFamily="Inter,sans-serif" opacity={opacity}>{children}</text>;

const products = [
  { name: 'Office Chair', price: '$299', icon: '🪑' },
  { name: 'Desk Lamp',    price: '$49',  icon: '💡' },
  { name: 'Monitor',      price: '$399', icon: '🖥' },
  { name: 'Keyboard',     price: '$89',  icon: '⌨' },
  { name: 'Mouse',        price: '$45',  icon: '🖱' },
  { name: 'Webcam',       price: '$99',  icon: '📷' },
];

const cartItems = [
  { name: 'Office Chair', qty: 2, price: '$598' },
  { name: 'Monitor',      qty: 1, price: '$399' },
  { name: 'Keyboard',     qty: 1, price: '$89'  },
];

const POSMockup = () => {
  const W = 480, H = 300;
  return (
    <Box sx={{ width: '100%', maxWidth: 520, position: 'relative', filter: 'drop-shadow(0 20px 40px rgba(22,51,0,0.20))', '& svg': { display: 'block', width: '100%', height: 'auto' } }}>
      <style>{`@keyframes posfU{from{opacity:0;transform:translateY(5px)}to{opacity:1;transform:translateY(0)}} @keyframes posPulse{0%,100%{opacity:1}50%{opacity:0.5}}`}</style>
      <svg viewBox={`0 0 ${W} ${H}`} xmlns="http://www.w3.org/2000/svg">
        <defs><linearGradient id="posg" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="white" stopOpacity="0.06"/><stop offset="100%" stopColor="white" stopOpacity="0"/></linearGradient></defs>
        <R x={0} y={0} w={W} h={H} fill={BG} rx={12} />
        {/* chrome */}
        <R x={0} y={0} w={W} h={26} fill={G2} rx={12} />
        <R x={0} y={14} w={W} h={12} fill={G2} />
        <circle cx={13} cy={13} r={4} fill="#ff5f57" />
        <circle cx={25} cy={13} r={4} fill="#febc2e" />
        <circle cx={37} cy={13} r={4} fill="#28c840" />
        <T x={W/2-16} y={17} size={7} fill={G1} weight={700}>POS</T>
        {/* topbar */}
        <R x={0} y={26} w={W} h={22} fill={G2} opacity={0.9} />
        <T x={10} y={41} size={6.5} fill={G1} weight={700}>FluxERP Point of Sale</T>
        {/* cashier info */}
        <circle cx={W-50} cy={37} r={8} fill={G1} opacity={0.2} />
        <T x={W-54} y={40} size={5.5} fill={G1} weight={700}>AH</T>
        <T x={W-38} y={40} size={5.5} fill={G1} opacity={0.7}>Ahmed</T>
        {/* session badge */}
        <R x={W-130} y={32} w={50} h={10} fill={G3} rx={5} opacity={0.2} />
        <circle cx={W-126} cy={37} r={2.5} fill={G3} style={{ animation: 'posPulse 1.5s ease-in-out infinite' }} />
        <T x={W-121} y={40} size={5} fill={G3} weight={600}>Session Active</T>

        {/* left: product grid */}
        <R x={0} y={48} w={290} h={H-48} fill="white" opacity={0.4} />
        {/* category tabs */}
        {['All', 'Furniture', 'Electronics', 'Accessories'].map((cat, i) => (
          <g key={cat}>
            <R x={6+i*68} y={52} w={62} h={13} fill={i===0?G2:BG} rx={6} opacity={i===0?0.9:0.7} />
            <T x={10+i*68} y={62} size={5.5} fill={i===0?G1:G2} weight={i===0?700:400}>{cat}</T>
          </g>
        ))}
        {/* search */}
        <R x={6} y={70} w={278} h={13} fill={BG} rx={6} opacity={0.8} />
        <T x={12} y={80} size={5.5} fill={G2} opacity={0.4}>🔍  Search products…</T>

        {/* product cards */}
        {products.map((p, i) => {
          const col = i % 3, row = Math.floor(i / 3);
          const px = 6 + col * 94, py = 88 + row * 96;
          return (
            <g key={p.name} style={{ animation: `posfU 0.4s ${0.05*i+0.1}s ease both` }}>
              <R x={px} y={py} w={88} h={88} fill="white" rx={6} opacity={0.85} />
              <R x={px+4} y={py+4} w={80} h={50} fill={G1} rx={4} opacity={0.12} />
              <T x={px+30} y={py+34} size={18} fill={G2} opacity={0.6}>{p.icon}</T>
              <T x={px+6} y={py+64} size={5.5} fill={G2} weight={600}>{p.name}</T>
              <T x={px+6} y={py+76} size={7}   fill={G4} weight={700}>{p.price}</T>
              <R x={px+58} y={py+68} w={24} h={14} fill={G1} rx={4} opacity={0.9} />
              <T x={px+63} y={py+78} size={8} fill={G2} weight={700}>+</T>
            </g>
          );
        })}

        {/* right: cart */}
        <R x={290} y={48} w={190} h={H-48} fill={G2} opacity={0.04} />
        <R x={290} y={48} w={190} h={18}   fill={G2} opacity={0.08} />
        <T x={298} y={60} size={6.5} fill={G2} weight={700}>Current Order</T>
        <T x={W-20} y={60} size={6.5} fill={G2} opacity={0.4}>✕</T>

        {/* cart items */}
        {cartItems.map((item, i) => (
          <g key={item.name} style={{ animation: `posfU 0.4s ${0.1+i*0.1}s ease both` }}>
            <R x={292} y={70+i*32} w={186} h={28} fill="white" rx={4} opacity={0.7} />
            <T x={298} y={82+i*32} size={6}   fill={G2} weight={600}>{item.name}</T>
            <T x={298} y={93+i*32} size={5.5} fill={G2} opacity={0.5}>Qty: {item.qty}</T>
            <T x={W-30} y={86+i*32} size={7}   fill={G4} weight={700}>{item.price}</T>
          </g>
        ))}

        {/* divider */}
        <line x1={292} y1={170} x2={W-8} y2={170} stroke={G2} strokeOpacity={0.1} strokeWidth={1} />

        {/* totals */}
        <T x={298} y={182} size={5.5} fill={G2} opacity={0.6}>Subtotal</T>
        <T x={W-42} y={182} size={6}   fill={G2} weight={600}>$1,086</T>
        <T x={298} y={194} size={5.5} fill={G2} opacity={0.6}>Tax (5%)</T>
        <T x={W-42} y={194} size={6}   fill={G2} weight={600}>$54.30</T>
        <R x={292} y={198} w={186} h={1} fill={G2} opacity={0.08} />
        <T x={298} y={210} size={7}   fill={G2} weight={700}>Total</T>
        <T x={W-58} y={210} size={9}   fill={G4} weight={800}>$1,140.30</T>

        {/* payment buttons */}
        <R x={292} y={216} w={88} h={22} fill={G1} rx={5} opacity={0.9} />
        <T x={308} y={230} size={6.5} fill={G2} weight={700}>💵 Cash</T>
        <R x={386} y={216} w={88} h={22} fill={G4} rx={5} opacity={0.85} />
        <T x={398} y={230} size={6.5} fill="white" weight={700}>💳 Card</T>

        {/* receipt badge */}
        <g style={{ animation: 'posfU 0.5s 1.2s ease both', opacity: 0 }}>
          <R x={292} y={242} w={186} h={22} fill={G3} rx={5} opacity={0.15} />
          <T x={298} y={256} size={6} fill={G4} weight={700}>✓ Last sale: $842 — 2 min ago</T>
        </g>

        <R x={0} y={0} w={W} h={H} fill="url(#posg)" rx={12} />
      </svg>
      <Box aria-hidden sx={{ position:'absolute', inset:'-1px', borderRadius:'13px', border:'1px solid rgba(22,51,0,0.10)', pointerEvents:'none' }} />
    </Box>
  );
};

export default POSMockup;
